module.exports = __webpack_public_path__ + "static/media/ic_more_gray.25ddf4de.svg";